import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CallListService } from '../../services/call-list.service';
import { Observable } from 'rxjs';
import { VisitorService } from '../../services/visitor.service';

@Component({
  selector: 'app-calllist-tabale',
  templateUrl: './calllist-tabale.component.html',
  styleUrls: ['./calllist-tabale.component.scss'],
})
export class CalllistTabaleComponent  {

 @Input() calls$: Observable<any[]> | null = null;
 @Input() visitorId: number | null = null;

@Input() pagination: { totalItems: number, itemsPerPage: number, currentPage: number } = { totalItems: 0, itemsPerPage: 20, currentPage: 1 }
 
   @Output() pageChange = new EventEmitter<number>(); 
  paginationSettings = {
  totalItems: 0,
  itemsPerPage: 20,
  currentPage: 1
};

operatorExtension: string = '';
  phoneQuery: string = '';
  status: string = '';
  dateFrom: string = '';
  dateTo: string = '';

  
  currentPage = 1;
  itemsPerPage = 20;

  pageSize = 2147483647;

  FHour: number = null;
  FMinutes: number = null;
  FSeconds: number = null;

  THour: number = null;
  TMinutes: number = null;
  TSeconds: number = null;


  durationFromHours = null;
  durationFromMinutes = null;
  durationFromSeconds = null;
  durationToHours = null;
  durationToMinutes = null;
  durationToSeconds = null;
  durationFromQuery: string = ''
  durationToQuery: string = ''
  phoneCallStatusQuery: string = ''
  phoneCallStatus: string = ''

  constructor(private router: Router, private callService : CallListService, private visitorService:VisitorService ) { }
 


async goToVisitorCard(id?: number | string, callId?: number | string, phoneNum?:number|string) {
  await this.router.navigate(['admin/manage-visitors'], { skipLocationChange: true });
  console.log("visitor id:", id);
  console.log("call id:", callId);

  localStorage.setItem("callId", String(callId));
  
  let cleanPhone = String(phoneNum);
  
if (cleanPhone.startsWith("+381")) {
  cleanPhone = cleanPhone.substring(4);
}
localStorage.setItem("phoneNum", cleanPhone);
 if(id != 0){  
  const visitor = await this.visitorService.getVisitorByIdTyped(Number(id)).toPromise();
   if (visitor.visitorStatus === 4) {
    
    await this.router.navigate(['admin/kartica-visitora']);
  } else {
   
    await this.router.navigate(['admin/kartica-visitora', id], {
    state: { visitor }  
  });
  }
  }else{
    await this.router.navigate(['admin/kartica-visitora']);
  }
}

getTimeFromServer(raw: string): string {
  if (!raw) return '';

  const date = new Date(raw); 

  const years = String(date.getFullYear());
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const days = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${days}-${month}-${years} ${hours}:${minutes}:${seconds}`;
}


   statusText(value: number) {
    switch (value) {
      case -1:
        return '-';
      case 0:
        return 'Zakazan';
      case 1:
        return 'Otkazan';
      case 2:
        return 'Raspituje se';
       case 3:
        return 'Razmisliće';
       case 4:
        return 'Pozvati ga';
         case 5:
        return 'Rezervisan';
      default:
        return '-';
    }
  }

  statusPhoneCallHelper(value: number) {
    if (value === 0) return 'ZAKAZIVANJE ROĐENDANA';
    if (value === 1) return 'OSTALI TELEFONSKI POZIVI';
    if (value === 2) return 'PROPUŠTEN POZIV';
    return '';
  }


}
